// extracted by mini-css-extract-plugin
module.exports = {"Video":"BackgroundVideo_Video__KHQ5O","Content":"BackgroundVideo_Content__1x8TG","SubContent":"BackgroundVideo_SubContent__gieub"};